module.exports = __webpack_public_path__ + "media/images/emails-and-contacts-triplet-1-b80cacc4a7ff80516823992123c72c06.svg";